/* eslint-disable react/prop-types */
import React, { useState } from "react";

import {
  ContainerMenuHamburguer,
  Block,
  HeaderButton,
  BackButtonContainer,
  SearchBarContainer,
  SearchInput,
  DesktopHeader,
  MobileHeader,
} from "./styles";

import Cart from "../Cart";
import { IconContext } from "react-icons";
import { IoMdClose } from "react-icons/io";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { HiChevronLeft } from "react-icons/hi";
import { HiOutlineChevronDown } from "react-icons/hi";
import { MagnifyingGlass } from "@phosphor-icons/react";
import { useNavigate, useMatch } from "react-router";
import { useOpen } from "../../hooks/Open";
import { useUserData } from "../../hooks/UserContext";
import { useApp } from "../../contexts/AppContext";
import { useFeatureFlag } from "../../contexts/FeatureFlagProvider";
import { trackClick } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../hooks/useScreenTracking";
import { useSearchVisibility } from "../../hooks/useSearchVisibility";
import notify from "../UI/toast";

function Header(props) {
  const { category, brands, closeAllMenu } = useOpen();
  const navigate = useNavigate();
  const { user, isPJ } = useUserData();
  const { whitelabel } = useApp();
  const screenName = useScreenTracking();
  const [searchQuery, setSearchQuery] = useState("");

  // Feature flags (mesma fonte usada pelo menu hamburguer)
  const travelEnabled = useFeatureFlag("travel");
  const hotelsEnabled = useFeatureFlag("hotels");
  const carRentalEnabled = useFeatureFlag("car_rental");
  const favoritesEnabled = useFeatureFlag("favorites");
  const showTravelMenu = travelEnabled || hotelsEnabled || carRentalEnabled;

  // Navegação da nav/dropdowns desktop (espelha o tracking do menu)
  const navTo = (title, path) => {
    trackClick({
      title,
      contentType: "menu",
      screenName,
      tagId: tagIdFromLegacySuffix("02"),
    });
    closeAllMenu();
    navigate(path);
  };

  const redirectHome = () => {
    trackClick({
      title: "logo-home",
      contentType: "header",
      screenName,
      tagId: tagIdFromLegacySuffix("01"),
    });
    closeAllMenu();
    navigate("/loja");
  };

  const handleGoBack = () => {
    trackClick({
      title: "botao-voltar",
      contentType: "header",
      screenName,
      tagId: tagIdFromLegacySuffix("01"),
    });
    closeAllMenu();
    navigate(-1);
  };

  const handleMenuToggle = () => {
    const isMenuOpen = props.open;
    const isInCategory = category || brands;

    if (isMenuOpen) {
      if (isInCategory) {
        trackClick({
          title: "voltar-categoria",
          contentType: "header",
          screenName,
          tagId: tagIdFromLegacySuffix("01"),
        });
        props.returnDiv();
      } else {
        trackClick({
          title: "fechar-menu",
          contentType: "header",
          screenName,
          tagId: tagIdFromLegacySuffix("01"),
        });
        props.sidebar();
      }
    } else {
      trackClick({
        title: "abrir-menu",
        contentType: "header",
        screenName,
        tagId: tagIdFromLegacySuffix("01"),
      });
      props.sidebar();
    }
  };

  const handleSearch = () => {
    if (searchQuery.length > 1) {
      trackClick({
        title: "buscar",
        contentType: "busca",
        screenName,
        tagId: tagIdFromLegacySuffix("12"),
      });
      navigate("/loja/products/" + searchQuery);
      setSearchQuery("");
    } else {
      notify("Digite pelo menos 2 caracteres no campo de busca", "error");
    }
  };

  // Rotas onde o botão voltar é oculto
  const isRouteHome = useMatch("/loja");
  const isRouteCheckoutTravelMessage = useMatch("/loja/checkout-message-travel/:id");
  const isRouteCheckoutTravelMessageNoId = useMatch("/loja/checkout-message-travel");
  const isRouteOrderResumeStatus = useMatch("/loja/orderresumestatus/:id");
  const isRouteOrderNotApproved = useMatch("/loja/ordernotapproved");
  const isRouteOrderPlaced = useMatch("/loja/orderplaced");
  const isRouteOrderPlacedSuccessfully = useMatch("/loja/orderplacedsuccessfully");
  const isRoutePixConfirmation = useMatch("/loja/pixconfirmation/:id");

  const shouldHideBackButton =
    isRouteHome ||
    isRouteCheckoutTravelMessage ||
    isRouteCheckoutTravelMessageNoId ||
    isRouteOrderResumeStatus ||
    isRouteOrderNotApproved ||
    isRouteOrderPlaced ||
    isRouteOrderPlacedSuccessfully ||
    isRoutePixConfirmation;

  // Rotas onde a busca é oculta
  const shouldShowSearch = useSearchVisibility();

  // Pontos visíveis quando payment_mode é "points" ou "both"
  const showPoints =
    whitelabel?.config?.payment_mode === "points" ||
    whitelabel?.config?.payment_mode === "both";

  return (
    <>
      <IconContext.Provider value={{ className: "custom-icon-wl" }}>
        <header
          className="header-wl"
          style={{ backgroundColor: whitelabel?.theme?.header_color }}
        >
          {/* ===== Desktop (>=1024px): header em linha única ===== */}
          <DesktopHeader className="header-desktop">
            <div className="hd-inner">
              <img
                src={whitelabel?.assets?.logo_url}
                alt={whitelabel?.assets?.name}
                className="hd-logo"
                onClick={() => redirectHome()}
              />

              <nav className="hd-nav">
                <button
                  type="button"
                  onClick={() => navTo("categorias", "/loja/categories/")}
                >
                  Categorias
                </button>
                <button
                  type="button"
                  onClick={() => navTo("marcas", "/loja/brands/")}
                >
                  Marcas
                </button>
                {showTravelMenu && (
                  <div className="hdrop" tabIndex={0}>
                    <span className="hdrop-toggle">
                      Viagens <HiOutlineChevronDown />
                    </span>
                    <div className="hdrop-menu">
                      {hotelsEnabled && (
                        <button
                          type="button"
                          onClick={() => navTo("hoteis", "/loja/hoteis/")}
                        >
                          Hotéis
                        </button>
                      )}
                      {travelEnabled && (
                        <button
                          type="button"
                          onClick={() =>
                            navTo("passagens-aereas", "/loja/passagens-aereas/")
                          }
                        >
                          Passagens aéreas
                        </button>
                      )}
                      {carRentalEnabled && (
                        <button
                          type="button"
                          onClick={() =>
                            navTo(
                              "aluguel-de-carros",
                              "/loja/search-cars-result",
                            )
                          }
                        >
                          Aluguel de carros
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </nav>

              {/* Desktop: busca sempre visível, independente da rota */}
              <div className="hd-search">
                <SearchInput>
                  <MagnifyingGlass size={20} color="#595959" />
                  <input
                    type="text"
                    placeholder={whitelabel?.theme?.search_field_header || `Buscar no ${whitelabel?.assets?.name || "marketplace"}`}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearch();
                      }
                    }}
                  />
                </SearchInput>
              </div>

              <div className="hd-actions">
                {showPoints && (
                  <span className="hd-points">
                    {user?.balance?.data &&
                      Math.floor(user?.balance?.data).toLocaleString("pt-BR")}{" "}
                    Pts
                  </span>
                )}
                <Cart />
                <div className="hdrop hdrop-account" tabIndex={0}>
                  <span className="hdrop-toggle">
                    Olá,{" "}
                    <span className="text-capitalize">
                      {user?.nome?.toLowerCase()}
                    </span>{" "}
                    <HiOutlineChevronDown />
                  </span>
                  <div className="hdrop-menu hdrop-menu-right">
                    <button
                      type="button"
                      onClick={() =>
                        navTo(
                          "minha-conta",
                          isPJ ? "/loja/pj/myaccount/" : "/loja/myaccount/",
                        )
                      }
                    >
                      Minha Conta
                    </button>
                    <button
                      type="button"
                      onClick={() => navTo("meus-pedidos", "/loja/myrequests/")}
                    >
                      Meus Pedidos
                    </button>
                    {favoritesEnabled && (
                      <button
                        type="button"
                        onClick={() => navTo("favoritos", "/loja/favorites/")}
                      >
                        Favoritos
                      </button>
                    )}
                    <button
                      type="button"
                      onClick={() => navTo("faq", "/loja/policy/")}
                    >
                      FAQ
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </DesktopHeader>

          {/* ===== Mobile / tablet (<1024px): layout original ===== */}
          <MobileHeader className="header-mobile">
          {/* Seção 1: Top Bar */}
          <Block className="header-top-bar">
            <div className="header-left">
              <img
                src={whitelabel?.assets?.logo_url}
                alt={whitelabel?.assets?.name}
                className="logo-wl"
                onClick={() => redirectHome()}
              />
            </div>
            <div className="header-right">
              <Cart />
              <ContainerMenuHamburguer>
                <HeaderButton type="button" onClick={handleMenuToggle}>
                  {props.open ? (
                    (props.open && category) || (props.open && brands) ? (
                      <HiChevronLeft className="return" />
                    ) : (
                      <IoMdClose />
                    )
                  ) : (
                    <HiOutlineMenuAlt3 />
                  )}
                </HeaderButton>
              </ContainerMenuHamburguer>
            </div>
          </Block>

          {/* Seção 2: Greeting Bar */}
          <Block
            className="d-flex justify-content-between align-items-center p-3 px-4"
            style={{
              color: whitelabel?.theme?.text_secondary_color,
              maxHeight: "57px",
              borderTop: "1px solid rgba(255, 255, 255, 0.3)",
            }}
          >
            {!shouldHideBackButton ? (
              <BackButtonContainer>
                <HeaderButton
                  type="button"
                  style={{
                    position: "relative",
                    right: "10px",
                  }}
                  onClick={handleGoBack}
                >
                  <HiChevronLeft />
                </HeaderButton>
                <span className="font-wl-500 text-md text-capitalize">
                  Olá, {user?.nome?.toLowerCase()}
                </span>
              </BackButtonContainer>
            ) : (
              <span className="font-wl-500 text-md text-capitalize">
                Olá, {user?.nome?.toLowerCase()}
              </span>
            )}
            {showPoints && (
              <span
                className="font-wl-700 text-mg"
                style={{ color: whitelabel?.theme?.text_secondary_color }}
              >
                {user?.balance?.data &&
                  Math.floor(user?.balance?.data).toLocaleString("pt-BR")}{" "}
                Pts
              </span>
            )}
          </Block>

          {/* Seção 3: Search Bar */}
          {shouldShowSearch && (
            <SearchBarContainer>
              <SearchInput>
                <MagnifyingGlass size={20} color="#595959" />
                <input
                  type="text"
                  placeholder={whitelabel?.theme?.search_field_header || `Buscar no ${whitelabel?.assets?.name || "marketplace"}`}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSearch();
                    }
                  }}
                />
              </SearchInput>
            </SearchBarContainer>
          )}
          </MobileHeader>
        </header>
      </IconContext.Provider>
    </>
  );
}

export default Header;